import React from "react";
import { Route, Switch } from "react-router-dom";
import "./App.css";
import WelcomePage from "components/WelcomePage";
import ColoringPage from "components/ColoringPage";
import ImageGallery from "components/ImageGallery/ImageGallery";
import CioffLogo from "./static/images/CioffWhiteLogo.png";
import UnescoLogo from "./static/images/unesco.svg";
import { useTranslation } from "react-i18next";

function App() {
  const { t, i18n } = useTranslation();
  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  return (
    <div className="App">
      <div className="background"></div>
      <div id="header">
        <a href="/" className="header-logos">
          <img src={CioffLogo} height={100} width={100} alt="CIOFF logo" />
          <img src={UnescoLogo} height={100} width={100} alt="UNESCO logo" />
          <h1 id="logo">
            {t("description.Coloring Countries")}
          </h1>
        </a>
        {/* <NavBar/> */}
        <div className="flex">
          <button onClick={() => changeLanguage("en")}>EN</button>
          <button onClick={() => changeLanguage("es")}>ES</button>
          <button onClick={() => changeLanguage("fr")}>FR</button>
        </div>
      </div>
      <div className="main-content">
        <Switch>
          <Route path="/" exact component={WelcomePage} />
          <Route path="/image-gallery" exact component={ImageGallery} />
          <Route path="/coloring-page/:id" exact component={ColoringPage} />
        </Switch>
      </div>
      <footer id="footer">
        <small>&copy; Copyright 2021. Developed by Z. Orozov & V. Fedyaev</small>
      </footer>
    </div>
  );
}

export default App;
